import { useState, useEffect } from "react";
import Title from "../../Text/Title/Title";
import { SubTitle } from "../../Text/Subtitle/SubTitle.tsx";
import { FormGroup, Input, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap";
import { useNotification } from "../../../hooks/useNotification";
import useApiRequests from "../../../hooks/useApiRequests.tsx";
import { IMember } from "../../../interfaces/IMember.tsx";
import { FillingBottle } from "react-cssfx-loading";
import BigText from "../../Text/BigText/BigText";
import { FaPen, FaTrash } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import "./register.css";
import { FcOk } from "react-icons/fc";
import { VscError } from "react-icons/vsc";
import {useTheme} from '../../../Context/ThemeContext';


export default function Register() {

  const { notify } = useNotification();
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();


  const { getBoardMembers, updateMember, deleteMembers } = useApiRequests();

  const [members, setMembers] = useState<IMember[] | null>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [idToDelete, setIdToDelete] = useState<string>("");

  async function handleUpdateMember(member: IMember) {
    var response = await updateMember(member);
    if (response.success)
      notify(`Registro alterado com sucesso`, { type: "success" });
  }

  useEffect(() => {
    fetchData();
  }, []);


  const fetchData = async () => {
    const data = await getBoardMembers();
    setMembers(JSON.parse(data.data));
  };

  const toggleMemberMetrics = (index: number) => {
    if (members != null) {
      const updatedMembers = [...members];
      updatedMembers[index].isInMetrics = !updatedMembers[index].isInMetrics;
      setMembers(updatedMembers);
      handleUpdateMember(updatedMembers[index]);
    }
  };

  const handleDeleteItem = async (id: string) => {
    const data = await deleteMembers(id);
    if (data.success) {
      notify("Usuário removido com sucesso", { type: "success" });
      fetchData();
      setDeleteModal(false);
    } else {
      notify(data.msg, { type: "error" });
    }
  };

  const handleEditItem = (id: string) => {
    navigate(`/member/edit/${id}`);
  };

  const handleNewItem = () => {
    navigate("/member/edit/new");
  };

  const handleGoBack = () => {
    const lastHref = localStorage.getItem("lastHref");
    window.location.href = lastHref || "";
  };


  return (
    <div className="page-container">
      <Row className="d-flex flex-wrap justify-content-between">
        <Col className="title-and-subtitle">
          <Title>Cadastro</Title>
          <SubTitle>Membros do quadro</SubTitle>
        </Col>

        <Col className="d-flex gap-2 justify-content-end">
          <Button
                color="secondary"
                style={{ height: "44px" }}
                onClick={() => handleGoBack()}
              >
                Voltar
              </Button>
          <Button
            color="success"
            style={{ height: "44px" }}
            onClick={() => handleNewItem()}
          >
            Novo membro
          </Button>
        </Col>
      </Row>


      <div className="mt-5">
        {members == null ? (
          <div className="d-flex flex-column justify-content-center align-items-center gap-5 mt-5">
            <BigText>Carregando...</BigText>
            <FillingBottle width="100px" height="100px" color="#dddcdc" />
          </div>
        ) : (
          
          <Table 
          responsive 
          size="" 
          // hover tirei o hover e striped pq n consegui adaptar para o dark-theme
          // striped
           >
            <thead className='theme-text-color'>
              <tr>
                <th>Nome</th>
                <th>Código</th>
                <th>Tipo</th>
                <th>Nível</th>
                <th style={{ textAlign: "center" }}>Triagem</th>
                <th>Incluir nas métricas</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {members != null &&
                members.map((member, index) => {
                  return (
                    <tr key={index} className="theme-text-color">
                      <td className="td-name">
                        {member?.fullName.length > 20
                          ? `${member.fullName.slice(0, 20)}...`
                          : member.fullName}
                      </td>
                      <td className="td-code">{member.loginCode}</td>
                      <td className="td-code">
                        {member.loginCode?.includes("Dev")
                          ? "Desenvolvedor"
                          : member.loginCode?.includes("Sup")
                          ? "Suporte"
                          : member.loginCode?.includes("Gere") ||
                            member.loginCode == null
                          ? "Gerenciador"
                          : "Testador"}
                      </td>
                      <td className="td-code">
                        {member.developerLevel == "JR"
                          ? "Júnior"
                          : member.developerLevel == "PL"
                          ? "Pleno"
                          : member.developerLevel == "SR"
                          ? "Sênior"
                          : "N/I"}
                      </td>
                      <td className="td-screening">
                        {member.canScreening != null ? (
                          member.canScreening == true ? (
                            <FcOk />
                          ) : (
                            <VscError color="red" />
                          )
                        ) : (
                          <VscError color="red" />
                        )}
                      </td>
                      <td className="td-include">
                        <FormGroup switch>
                          <Input
                            type="switch"
                            checked={member.isInMetrics}
                            onChange={() => {
                              toggleMemberMetrics(index);
                            }}
                          />
                        </FormGroup>
                      </td>
                      <td className="td-edit">
                        <FaPen
                          className="pointer"
                          color="#0d6efd"
                          onClick={() => handleEditItem(member.id || "")}
                        />
                      </td>
                      <td className="td-edit">
                        <FaTrash
                          className="pointer"
                          color="red"
                          onClick={() => {setDeleteModal(true); setIdToDelete(member.id || "")}}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}
      </div>
      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
        <ModalHeader toggle={() => setDeleteModal(false)}>
          Deletar Usuário
        </ModalHeader>
        <ModalBody>
          Esta ação não poderá ser desfeita! Tem certeza que deseja deletar?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleDeleteItem(idToDelete)}>
            Deletar
          </Button>{" "}
          <Button color="secondary" onClick={() => setDeleteModal(false)}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}
